export default __webpack_public_path__ + "static/custom-marker-shapes-50ec8c6eebabd855bba5d9f6068665cd.png";